import React, { Component, Fragment } from "react";
import _ from "lodash";
import { arrayOf, shape, string, number } from "prop-types";
import { LabeledContainer } from "src/components/layout";
import { Button } from "src/components/shared";
import { ReactComponent as Rank1 } from "src/images/rank-1.svg";
import { ReactComponent as Rank2 } from "src/images/rank-2.svg";
import { ReactComponent as Rank3 } from "src/images/rank-3.svg";
import { CUSTOM_ATTR_NA } from "src/util/PrioritizeUtil";
import Comments from "src/pages/Prioritize/Comments";

class HowToReadStats extends Component {
  state = { expanded: true };

  onClick = () => {
    this.setState({ expanded: !this.state.expanded });

    const { onShowMoreStatsClick } = this.props;

    if (onShowMoreStatsClick) onShowMoreStatsClick();
  };

  render() {
    const { detailsData, ...other } = this.props;
    const { expanded } = this.state;
    return expanded ? (
      <div {...other}>
        <p>HOW DO I READ THESE STATS</p>
        <LabeledContainer title="Weighted Rating">
          Average of all rating submitted by each participant multiplied by the
          factor weight
        </LabeledContainer>
        <LabeledContainer title="STD (Standard Deviation)">
          Standard deviation tells you how spread out the data is. It is a
          measure of how far each observed value is from the mean.
        </LabeledContainer>
        <Button sm primary submit onClick={this.onClick}>
          Show me more stats
        </Button>
      </div>
    ) : (
      ""
    );
  }
}

class CollapsedDetails extends Component {
  state = { expanded: false, isShowMoreStats: false };

  onClick = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  formatData = (value, fractionDigits) => {
    return value || value === 0 ? value.toFixed(fractionDigits) : "-";
  };

  render() {
    const {
      collectionId,
      detailsData,
      description,
      comments = {},
    } = this.props;
    const { isShowMoreStats } = this.state;
    const thLists = {
      basic_th: ["", "WEIGHT", "AVG RATING", "WEIGHTED AVG", "STD"],
      expandable_th: ["MIN", "MAX"],
    };

    return (
      <tr>
        <td colSpan="7">
          <p>{description}</p>
          <div className="results-table__collapse_details">
            <div className="results-table__collapse_details__stats">
              <table>
                <thead>
                  <tr>
                    {thLists.basic_th.map((text) => (
                      <th key={text}>{text}</th>
                    ))}
                    {isShowMoreStats &&
                      thLists.expandable_th.map((text) => (
                        <th key={text}>{text}</th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {detailsData.map((rowData, idx) => (
                    <tr key={idx}>
                      <td>{rowData.title}</td>
                      <td>{_.get(rowData, "weight", "-")}</td>
                      <td>{this.formatData(rowData.avg_rating, 1)}</td>
                      <td>{this.formatData(rowData.avg_weighted_score, 1)}</td>
                      <td>{this.formatData(rowData.std_dev, 2)}</td>
                      {isShowMoreStats && (
                        <Fragment>
                          <td>{_.get(rowData, "min", "-")}</td>
                          <td>{_.get(rowData, "max", "-")}</td>
                        </Fragment>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <HowToReadStats
              className="results-table__collapse_details__hint"
              onShowMoreStatsClick={() =>
                this.setState({ isShowMoreStats: true })
              }
            />
          </div>

          <div className="comments-count">
            Comments ({comments[collectionId] ? comments[collectionId].length : 0})
          </div>

          <Comments readOnly collectionId={collectionId} />
        </td>
      </tr>
    );
  }
}

CollapsedDetails.propTypes = {
  detailsData: arrayOf(
    shape({
      title: string.isRequired,
      result: shape({
        avg_rating: number,
        std: number,
      }),
    })
  ),
};

CollapsedDetails.defaultProps = {
  detailsData: [],
};

class TableRow extends Component {
  state = { expanded: false };

  onClick = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  formatData = (value, fractionDigits) => {
    return value || value === 0 ? value.toFixed(fractionDigits) : "-";
  };

  render() {
    const { collection, rowData, idx, customAttr1Label, comments, ...other } = this.props;
    const svgSize = { viewBox: "0 0 60 55", height: "40", width: "20" };
    const trophies = [
      <Rank1 {...svgSize} />,
      <Rank2 {...svgSize} />,
      <Rank3 {...svgSize} />,
    ];

    let rankLeftPadding = "20px";
    if (idx === 1) {
      rankLeftPadding = "26px";
    } else if (idx === 2) {
      rankLeftPadding = "24px";
    }
    const rankStyle = {
      paddingLeft: rankLeftPadding,
    };

    console.log("rowData", rowData);

    return (
      <Fragment>
        <tr onClick={this.onClick} {...other}>
          <td className="item-title">{rowData.title}</td>
          <td className="item-rank" style={rankStyle}>
            {idx < 3 ? trophies[idx] : idx + 1}
          </td>
          <td>{this.formatData(rowData.avg_weighted_score, 1)}</td>
          <td>{this.formatData(rowData.total_weighted_score, 0)}</td>
          <td>{rowData.participants} of {collection.participant} ({collection.participant > 0 ? `${parseInt(rowData.participants / collection.participant * 100)}%` : "-"})</td>
          {customAttr1Label !== CUSTOM_ATTR_NA && (
            <td>{_.get(rowData, "custom_attr_1", "-")}</td>
          )}
          <td>
            {this.state.expanded ? (
              <i className="material-icons">expand_less</i>
            ) : (
              <i className="material-icons">expand_more</i>
            )}
          </td>
        </tr>
        {this.state.expanded && (
          <CollapsedDetails
            collectionId={rowData.id}
            detailsData={rowData.questions}
            description={rowData.description}
            comments={comments}
          />
        )}
      </Fragment>
    );
  }
}

TableRow.propTypes = {
  rowData: shape({
    title: string.isRequired,
    result: shape({
      avg_overall_rating: number,
      avg_overall_weighted_score: number,
    }),
  }),
};

TableRow.defaultProps = {
  rowData: [],
};

class Table extends Component {
  render() {
    const { data, collection, comments } = this.props;
    const lastColumnName = collection.custom_attr_1;
    return (
      <table className="results-table">
        <thead>
          <tr>
            <th></th>
            <th>RANK</th>
            <th>OVERALL RATING</th>
            <th>WEIGHTED SCORE</th>
            <th>PARTICIPATION</th>
            {lastColumnName && lastColumnName !== CUSTOM_ATTR_NA && (
              <th>{lastColumnName && lastColumnName.toLocaleUpperCase()}</th>
            )}
          </tr>
        </thead>
        <tbody>
          {data.map((rowItem, rowIdx) => (
            <TableRow
              key={rowIdx}
              idx={rowIdx}
              rowData={rowItem}
              collection={collection}
              customAttr1Label={lastColumnName}
              comments={comments}
            />
          ))}
        </tbody>
      </table>
    );
  }
}

// Table.propTypes = {
//   expandable: bool
// };

// Table.defaultProps = {
//   expandable: false
// };

export default class TableView extends Component {
  render() {
    const { data, collection, comments } = this.props;

    return (
      <Table
        expandable
        collection={collection}
        data={data}
        comments={comments}
      />
    );
  }
}

TableView.propTypes = {
  data: arrayOf(
    shape({
      title: string.isRequired,

      questions: arrayOf(
        shape({
          title: string.isRequired,

          result: shape({
            avg_rating: number,
            std: number,
          }),
        })
      ),
    })
  ),
};

TableView.defaultProps = {
  data: [],
};
